export class Log {
    public id: number;
    public user_id: number;
    public reservation_id: number;
    public blocked_date_id: number;
    public action: string;
    public ip_address: string;
    public created: string;

    constructor(id: number, user_id: number, action: string, ip_address: string, created: string
                , reservation_id?: number, blocked_date_id?: number) {
        this.id = id;
        this.user_id = user_id;
        this.reservation_id = reservation_id;
        this.blocked_date_id = blocked_date_id;
        this.action = action;
        this.ip_address = ip_address;
        this.created = created;
    }
}

export class LogCreate {
    public user_id: number;
    public reservation_id: number;
    public blocked_date_id: number;
    public action: string;
    public ip_address: string;

    constructor(user_id: number, action: string, ip_address: string, reservation_id?: number, blocked_date_id?: number) {
        this.user_id = user_id;
        this.reservation_id = reservation_id;
        this.blocked_date_id = blocked_date_id;
        this.action = action;
        this.ip_address = ip_address;
    }
}


